export default __webpack_public_path__ + "static/media/blue_neon_line_left.670f5470.svg";